import {WebGLBrandedDivider} from '@github-ui/brand-webgl'
import {Hero} from '@primer/react-brand'

import Styles from './CtaBanner.module.css'

export interface CtaBannerProps {
  label: string
  heading: string
  body: string
  cta1: {
    label: string
    href: string
  }
  cta2: {
    label: string
    href: string
  }
}

export const CtaBanner = ({label, heading, body, cta1, cta2}: CtaBannerProps) => {
  return (
    <div className={Styles['CtaBanner']}>
      <Hero
        className={Styles['CtaBanner__hero']}
        variant="gridline"
        align="center"
        enableAnimation
        aria-label={heading}
        aria-labelledby={undefined}
      >
        <Hero.Label>{label}</Hero.Label>
        <Hero.Heading {...({as: 'h2'} as Record<string, unknown>)}>{heading}</Hero.Heading>

        <Hero.Description>{body}</Hero.Description>
        <Hero.PrimaryAction href={cta1.href}>{cta1.label}</Hero.PrimaryAction>
        <Hero.SecondaryAction href={cta2.href}>{cta2.label}</Hero.SecondaryAction>
      </Hero>

      <WebGLBrandedDivider
        className={Styles['CtaBanner__brandedDivider']}
        params={{
          character: 'invertocat',
          layout: 1,
        }}
      />
    </div>
  )
}
